import { Component } from '@angular/core';
import { ApiService } from '../api.service';
import { HandlerService } from '../handler.service';
import { ToastService } from '../toast.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-create-brand',
  templateUrl: './create-brand.component.html',
  styleUrls: ['./create-brand.component.scss'],
})
export class CreateBrandComponent {
  code;
  name;
  description;
  loader: boolean = false;
  active: boolean = true;
  pic:any;
  editBool:boolean=false;
  activeInd: boolean = true;
  item:any;
  fontStyle;
  id;
  category;
  cateName;
  cateId;
constructor(public service: ApiService,
  public handler: HandlerService,
  public toast: ToastService,
  public translate: TranslateService,
  private bottomSheet: MatBottomSheet,
  public router: Router,
  public platform:Platform,
  public auth:AuthService) { }
  ionViewWillEnter() {
  this.fontStyle=localStorage.getItem('lang');
  let url=window.location.href
  if(url.includes('edit')) {
    this.loader=true;
    this.editBool=true;
    this.id= window.location.href.split('/').pop();
    this.service.getBrandById(this.id).subscribe((res:any)=>{
      this.item=res;
        this.code = res.code;
        this.name = res.name;
        this.description= res.description;
        this.activeInd = res.activeInd;
        this.cateId = res.purchaseCategory;
        this.pic=res.img; 
        setTimeout(() => {
          this.category.map(res1 => {
            if (res1.id == this.cateId) {
              this.cateName = res1.name;
              this.cateId = res1.id;
            }
          })
        }, 1000);
    })
    err=>{
      this.handler.err(err);
      this.loader=false;
    }
  }
  else{
    this.editBool = false;
  }
this.getCategory();
}

getCategory(){
  this.service.getAllPurchaseCategory().subscribe((res:any)=>{
    this.category=res;
    this.category.map(dat=>{
      if(dat.id==this.cateId){
        this.cateName = dat.name;
      }
    })
    this.loader=false;
  })
}

openBottomSheet(){
  const dialogRef = this.bottomSheet.open(BottomSheet, {
    data: this.category,
  });
  dialogRef.afterDismissed().subscribe((res) => {
    if (res) {
      this.cateName = res.name;
      this.cateId = res.id;  
      }
  });
}

  create() {
    if(this.cateId){
      this.loader = true;
      var post={
        "code": this.code,
        "name": this.name,
        "description": this.description,
        "img": this.pic,
        "purchaseCategory":this.cateId,
        activeInd: true
      }
      this.service.createBrand(post).subscribe(res=>{
        this.handler.res("Brand Created Successfully");
        this.loader = false;
        this.router.navigate(['manage-brands'])
  
      },
      err=>{
        this.loader=false;
        this.handler.err(err);
      })
    }else{
      this.handler.err('Please Enter Required Fields')
    }
 
  }
  editService() {
    if(this.cateId){   
      this.loader = true;
    if (this.name) {
      this.name = this.name.toUpperCase();
    }
    if (!this.pic) {
      var img = new Image();
      img.src="assets/setting.png"
      var canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);    
      this.pic = canvas.toDataURL('image/jpeg', 1.5);  
    }
    
    this.loader = true;
    this.item.code=this.code;
    this.item.name=this.name;
    this.item.img = this.pic;
    this.item.description=this.description;
    this.item.activeInd = this.activeInd;
    this.item.purchaseCategory = this.cateId;
    this.service.updateBrand(this.id,this.item).subscribe(res=>{
      this.handler.res("Brand Updated Successfully");
      this.loader = false;
      this.router.navigate(['/manage-brands'])

    },
    err=>{
      this.loader=false;
      this.handler.err(err);

    })
  }else{
    this.handler.err('Please Enter Required Fields')
  }
  }

  handleFile(files) {
    if (files[0].size < 1048576) {
      var img = new Image();
      img.src = URL.createObjectURL(files[0]);
      img.onload = (data) => {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        this.pic = canvas.toDataURL('image/jpeg', 1.5);
      }
    }
    else {
      this.handler.res('Image Size Should Not Exceeds 1mb ');
    }

  }  
  
  ionViewWillLeave(){
    this.code="";
    this.name="";
    this.pic="";
    this.description="";
    this.cateId="";
    this.cateName="";
  }
}
